var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.23,13.23h7.52c.33,0,.65-.12.88-.36.23-.23.36-.55.36-.88s-.13-.65-.36-.88c-.23-.23-.55-.36-.88-.36h-7.52s0-7.51,0-7.51c0-.33-.13-.65-.36-.88-.23-.23-.55-.36-.88-.36s-.65.13-.88.36c-.23.23-.36.55-.36.88v7.52s-7.51,0-7.51,0c-.16,0-.33.03-.48.09-.15.06-.29.15-.4.27-.12.12-.21.25-.27.4-.06.15-.09.31-.09.48,0,.16.03.33.09.48.06.15.15.29.27.4.12.12.25.21.4.27.15.06.31.09.48.09h7.52s0,7.51,0,7.51c0,.16.03.33.09.48.06.15.15.29.27.4.12.12.25.21.4.27.15.06.31.09.48.09.16,0,.33-.03.48-.09.15-.06.29-.15.4-.27.12-.12.21-.25.27-.4.06-.15.09-.31.09-.48v-7.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.cdbd18ffb436d682edbea49292d93210.svg";
export { ForwardRef as ReactComponent };